// view.js
window.addEventListener('load', () => {

	const mq = window.matchMedia('(max-width: 760px)');
	let lastScrollBeforeHash = null;

	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	// ------------------------------------------------------------------
	// Détecte le vrai conteneur de scroll.
	// Sur certains thèmes WP (dont ITU), c'est document.body qui scroll
	// et non window/document.documentElement. window.scrollY renvoie alors
	// toujours 0 et window.scrollTo() n'a aucun effet.
	// ------------------------------------------------------------------
	const _scrollEl = (() => {
		if (document.body.scrollHeight > document.body.clientHeight) {
			const saved = document.body.scrollTop;
			document.body.scrollTop = saved + 1;
			if (document.body.scrollTop !== saved) {
				document.body.scrollTop = saved;
				return document.body;
			}
			document.body.scrollTop = saved;
		}
		return null; // utilise window
	})();

	function getScrollY() {
		return _scrollEl ? _scrollEl.scrollTop : window.pageYOffset;
	}

	function scrollTo(top, behavior = 'smooth') {
		if (_scrollEl) {
			_scrollEl.scrollTo({ top, behavior });
		} else {
			window.scrollTo({ top, behavior });
		}
	}

	// ------------------------------------------------------------------
	// Sticky offset — cherche la vraie balise <header> fixe/sticky
	// (certains thèmes n'utilisent pas .site-header ni #wpadminbar)
	// ------------------------------------------------------------------
	function getStickyOffset() {
		let h = 0;

		const admin = document.getElementById('wpadminbar');
		if (admin) h += admin.offsetHeight;

		const headerSelectors = [
			'.site-header',
			'header.sticky',
			'header[class*="sticky"]',
			'header[class*="fixed"]',
			'header'
		];
		for (const sel of headerSelectors) {
			const el = document.querySelector(sel);
			if (!el) continue;
			const pos = getComputedStyle(el).position;
			if (pos === 'fixed' || pos === 'sticky') {
				h += el.offsetHeight;
				break;
			}
		}

		return h;
	}

	const EXTRA_TWEAK = 20;

	function scrollToAcc(acc) {
		const target = acc.querySelector('.accordion-title') || acc;
		const absY = target.getBoundingClientRect().top + getScrollY();
		const top = absY - getStickyOffset() - EXTRA_TWEAK;
		scrollTo(top);
	}

	// ------------------------------------------------------------------
	// Helpers
	// ------------------------------------------------------------------
	const isAccordion = (el) =>
		el?.classList?.contains('wp-block-brblocks-accordion');

	function getLogicalParent(acc) {
		let p = acc.parentElement;
		while (p && p !== document.body) {
			if (isAccordion(p) || p.classList.contains('accordion-content')) {
				p = p.parentElement;
				continue;
			}
			const siblings = [...p.querySelectorAll('.wp-block-brblocks-accordion')]
				.filter(el => el !== acc);
			if (siblings.length >= 1) return p;
			p = p.parentElement;
		}
		return null;
	}

	function closeOnlySiblings(acc) {
		const parent = getLogicalParent(acc);
		if (!parent) return;
		parent.querySelectorAll('.wp-block-brblocks-accordion')
			.forEach(sib => { if (sib !== acc) closeAccordion(sib); });
	}

	function closeAccordion(acc) {
		acc.classList.remove('open');
		const title = acc.querySelector('.accordion-title');
		const c = acc.querySelector('.accordion-content');
		title?.classList.remove('active');
		title?.setAttribute('aria-expanded', 'false');
		if (c) {
			c.classList.remove('open');
			if (mq.matches) c.style.maxHeight = '0px';
		}
	}

	function openAccordion(acc, { scroll = true } = {}) {
		const c = acc.querySelector('.accordion-content');
		const title = acc.querySelector('.accordion-title');
		if (!c) return;
		acc.classList.add('open');
		c.classList.add('open');
		title?.classList.add('active');
		title?.setAttribute('aria-expanded', 'true');
		if (mq.matches) c.style.maxHeight = c.scrollHeight + 'px';
		if (scroll) requestAnimationFrame(() => scrollToAcc(acc));
	}

	// ------------------------------------------------------------------
	// Ouvre l'accordéon et scrolle après la fin de la transition
	// de fermeture du sibling situé AU-DESSUS (s'il y en a un).
	// ------------------------------------------------------------------
	function openAndScroll(acc) {
		const accViewportTop = acc.getBoundingClientRect().top;
		const parent = getLogicalParent(acc);
		let siblingAbove = null;

		if (parent) {
			parent.querySelectorAll('.wp-block-brblocks-accordion').forEach(sib => {
				if (sib !== acc && sib.classList.contains('open')) {
					if (sib.getBoundingClientRect().top < accViewportTop) {
						siblingAbove = sib;
					}
				}
			});
		}

		closeOnlySiblings(acc);
		openAccordion(acc, { scroll: false });

		const doScroll = () => {
			requestAnimationFrame(() => scrollToAcc(acc));
		};

		if (!siblingAbove) {
			doScroll();
			return;
		}

		const c = siblingAbove.querySelector('.accordion-content');
		if (!c) { doScroll(); return; }

		const TRANSITION_MS = 400;
		const fallback = setTimeout(doScroll, TRANSITION_MS);

		c.addEventListener('transitionend', function onEnd(e) {
			if (e.target !== c || e.propertyName !== 'max-height') return;
			clearTimeout(fallback);
			c.removeEventListener('transitionend', onEnd);
			doScroll();
		});
	}

	// ------------------------------------------------------------------
	// Scroll après fermeture
	// Sur desktop, max-height n'est pas animé inline → setTimeout direct.
	// ------------------------------------------------------------------
	const CSS_CLOSE_DURATION_MS = 350;

	function scrollAfterClose(targetY, refAcc = null) {
		if (mq.matches) {
			const c = refAcc
				? refAcc.querySelector('.accordion-content')
				: document.querySelector('.wp-block-brblocks-accordion .accordion-content');

			if (!c) {
				scrollTo(targetY);
				return;
			}

			const fallback = setTimeout(() => scrollTo(targetY), CSS_CLOSE_DURATION_MS + 100);

			c.addEventListener('transitionend', function onEnd(e) {
				if (e.target !== c || e.propertyName !== 'max-height') return;
				clearTimeout(fallback);
				c.removeEventListener('transitionend', onEnd);
				scrollTo(targetY);
			});
		} else {
			setTimeout(() => scrollTo(targetY), CSS_CLOSE_DURATION_MS);
		}
	}

	// ------------------------------------------------------------------
	// Capturer scrollY sur mousedown — avant tout saut navigateur
	// ------------------------------------------------------------------
	document.addEventListener('mousedown', (e) => {
		const link = e.target.closest('a[href^="#"]');
		if (!link) return;
		const id = decodeURIComponent(link.getAttribute('href').slice(1));
		if (!id) return;
		const acc = document.getElementById(id);
		if (!acc || !isAccordion(acc)) return;
		lastScrollBeforeHash = getScrollY();
	});

	// ------------------------------------------------------------------
	// EVENT DELEGATION — click
	// ------------------------------------------------------------------
	document.addEventListener('click', (e) => {

		// Title click
		const title = e.target.closest('.accordion-title');
		if (title) {
			const acc = title.closest('.wp-block-brblocks-accordion');
			if (!acc) return;
			const wasOpen = acc.classList.contains('open');
			if (wasOpen) {
				closeAccordion(acc);
			} else {
				openAndScroll(acc);
			}
			return;
		}

		// Hash links vers un accordéon
		const link = e.target.closest('a[href^="#"]');
		if (!link) return;

		const id = decodeURIComponent(link.getAttribute('href').slice(1));
		if (!id) return;

		const acc = document.getElementById(id);
		if (!acc || !isAccordion(acc)) return;

		e.preventDefault();

		const savedY = lastScrollBeforeHash ?? getScrollY();

		// Déjà ouvert → fermer + retirer le hash
		if (acc.classList.contains('open')) {
			closeAccordion(acc);
			history.replaceState(
				{ scrollY: savedY },
				'',
				window.location.pathname + window.location.search
			);
			scrollAfterClose(savedY, acc);
			return;
		}

		// pushState APRÈS ouverture pour ne pas déclencher un scroll natif
		openAndScroll(acc);
		history.pushState({ scrollY: savedY }, '', '#' + id);
	});

	// ------------------------------------------------------------------
	// KEYBOARD
	// ------------------------------------------------------------------
	document.addEventListener('keydown', (e) => {
		const title = e.target.closest('.accordion-title');
		if (!title) return;
		const acc = title.closest('.wp-block-brblocks-accordion');
		if (!acc) return;
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			const wasOpen = acc.classList.contains('open');
			if (wasOpen) {
				closeAccordion(acc);
			} else {
				closeOnlySiblings(acc);
				openAccordion(acc, { scroll: false });
			}
		}
		if (e.key === 'Escape' && acc.classList.contains('open')) {
			e.preventDefault();
			closeAccordion(acc);
		}
	});

	// ------------------------------------------------------------------
	// POPSTATE — back / forward
	// ------------------------------------------------------------------
	window.addEventListener('popstate', (e) => {
		const id = decodeURIComponent(window.location.hash.replace('#', ''));

		if (!id) {
			const openAccs = [...document.querySelectorAll('.wp-block-brblocks-accordion.open')];
			openAccs.forEach(acc => closeAccordion(acc));

			const savedY = e?.state?.scrollY ?? lastScrollBeforeHash;
			if (savedY !== null && savedY !== undefined) {
				scrollAfterClose(savedY, openAccs[0] ?? null);
			}
		} else {
			const acc = document.getElementById(id);
			if (!acc || !isAccordion(acc)) return;
			openAndScroll(acc);
		}
	});

	// ------------------------------------------------------------------
	// Chargement initial avec hash
	// ------------------------------------------------------------------
	if (window.location.hash) {
		const id = decodeURIComponent(window.location.hash.replace('#', ''));
		const acc = document.getElementById(id);
		if (acc && isAccordion(acc)) {
			closeOnlySiblings(acc);
			openAccordion(acc, { scroll: true });
		}
	}

	// ------------------------------------------------------------------
	// Responsive
	// ------------------------------------------------------------------
	function applyMode() {
		document.querySelectorAll('.wp-block-brblocks-accordion').forEach(acc => {
			const c = acc.querySelector('.accordion-content');
			if (!c) return;
			if (mq.matches) {
				c.style.maxHeight = acc.classList.contains('open')
					? c.scrollHeight + 'px'
					: '0px';
			} else {
				c.style.maxHeight = null;
			}
		});
	}

	applyMode();
	mq.addEventListener('change', applyMode);

	let resizeTimer = null;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			if (!mq.matches) return;
			document.querySelectorAll('.wp-block-brblocks-accordion').forEach(acc => {
				const c = acc.querySelector('.accordion-content');
				if (c && acc.classList.contains('open')) {
					c.style.maxHeight = c.scrollHeight + 'px';
				}
			});
		}, 120);
	});
});